import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import CryptoJS from 'crypto-js';
import image from '../assets/images/BashaaratLogo.svg';
import leftimage from '../assets/images/login-left-img.png'
import defaultemail from '../assets/images/default-email-text-img.png'
import defaultpass from '../assets/images/default-pwd-text-img.png'
import emailimage from '../assets/images/email-text-img.png';
import passimage from '../assets/images/pwd-text-img.png';
import '../styles/AdminLogin.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const AdminLogin = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isEmailFocused, setIsEmailFocused] = useState(false);
  const [isPasswordFocused, setIsPasswordFocused] = useState(false);

  const navigate = useNavigate();

  const encryptPassword = (password) => {
    const key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_SECRET_KEY);
    const iv = CryptoJS.lib.WordArray.random(16);

    const encrypted = CryptoJS.AES.encrypt(password, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });

    const combined = iv.concat(encrypted.ciphertext);
    return CryptoJS.enc.Base64.stringify(combined);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');


    const encryptedPassword = encryptPassword(password);

    try {
      const response = await api.post('api/admin/login', { email, password: password  })

      if (response.data.status === "success") {
        localStorage.setItem('admin', JSON.stringify(response.data.data));
        localStorage.setItem('expiresAt', Date.now() + 1 * 24 * 60 * 60 * 1000);
        onLogin(response.data.data);
        navigate('/dashboard');
      }
    } catch (error) {
      if (error.response && error.response.data) {
        setErrorMessage(error.response.data.message);
      } else {
        setErrorMessage('Something went wrong. Please try again later.');
      }
    }
  };

  return (
    <div>
      <section>
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12 col-md-2 col-lg-12">
              <div className="form-container-login">
                <div className="row">
                  <div className="col-lg-6 p-0">
                    <img className="img-fluid hideinmob" src={leftimage} alt="" style={{ height: '100vh', width: '100%' }} />
                  </div>
                  <div className="col-lg-6 form-center">
                    <div className="login-logo text-center">
                      <img className="logoimg imginmob" src={image} alt="" />
                    </div>
                    <div className="login-head text-center">
                      {/* <h2 className="login-heading">Welcome Back</h2> */}
                    </div>
                    <div className="login-border">
                      <form class="login-form" onSubmit={handleSubmit}>
                        <div className="input-container" style={{ borderBottom: isEmailFocused ? '1px solid #BC6C25' : '1px solid #E4C8AF' }}>
                          <img className="img-fluid" src={isEmailFocused ? emailimage : defaultemail} alt="" />
                          <input
                            type="text"
                            className="email-placeholder"
                            placeholder="Email"
                            onFocus={() => setIsEmailFocused(true)}
                            onBlur={() => setIsEmailFocused(false)}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                          />
                        </div>
                        <div className="input-container" style={{ borderBottom: isPasswordFocused ? '1px solid #BC6C25' : '1px solid #E4C8AF' }}>
                          <img className="img-fluid" src={isPasswordFocused ? passimage : defaultpass} alt="" />
                          <input
                            type="password"
                            className="password-placeholder"
                            placeholder="Password"
                            onFocus={() => setIsPasswordFocused(true)}
                            onBlur={() => setIsPasswordFocused(false)}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                          />
                        </div>
                        {errorMessage && <div className="alert alert-danger mt-3">{errorMessage}</div>}
                        <button type="submit" className="login-btn">
                          Login
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
          </div>
        </div>
      </section>
    </div>
  );
};

export default AdminLogin;
